<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-card class="mb-0">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Detalle de Cuenta Corriente</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-if="!loading && jugador">
        <v-row class="mt-4">
          <v-col cols="12">
            <v-card outlined>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <strong>Jugador:</strong> {{ jugador.apellidos }},
                    {{ jugador.nombres }}
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <strong>Saldo actual:</strong>
                    <v-chip
                      class="ml-2"
                      :color="
                        saldoTotal > 0
                          ? 'error'
                          : saldoTotal < 0
                          ? 'success'
                          : 'grey'
                      "
                      dark
                      small
                    >
                      ${{ saldoTotal.toFixed(2) }}
                    </v-chip>
                  </v-col>
                </v-row>
                <v-row class="mt-2">
                  <v-col cols="12">
                    <v-alert color="info" dense outlined>
                      <v-icon left color="red">mdi-alert-circle</v-icon>
                      <strong>Saldo positivo (rojo):</strong> Deuda del jugador
                      <v-icon left color="green" class="ml-4"
                        >mdi-check-circle</v-icon
                      >
                      <strong>Saldo negativo (verde):</strong> Saldo a favor del
                      jugador
                    </v-alert>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="mt-4">
          <v-col cols="12">
            <v-chip label color="transparent" text-color="black">
              <h3>Movimientos</h3>
            </v-chip>
          </v-col>
        </v-row>

        <v-data-table
          v-if="movimientos.length > 0"
          :headers="headers"
          :items="movimientos"
          class="elevation-1"
          locale="es-ar"
          item-key="idMovimiento"
          :items-per-page="10"
          :footer-props="{
            itemsPerPageText: 'Filas por página',
            itemsPerPageOptions: [5, 10, 15, 20],
          }"
        >
          <template v-slot:item.tipo="{ item }">
            <v-chip
              :color="item.tipo === 'DEUDA' ? 'error' : 'success'"
              dark
              small
            >
              {{ item.tipo }}
            </v-chip>
          </template>
          <template v-slot:item.monto="{ item }">
            <span
              :class="item.tipo === 'DEUDA' ? 'error--text' : 'success--text'"
            >
              ${{ Math.abs(item.monto.toFixed(2)) }}
            </span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  color="red"
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="eliminarMovimiento(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>Eliminar movimiento</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-alert v-else color="purple" dark outlined class="mt-4">
          No hay movimientos registrados para este jugador.
        </v-alert>
      </v-card-text>
      <v-card-text v-else-if="loading">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
        Cargando...
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="saldoTotal > 0"
          color="success"
          @click="abrirCancelarDeuda"
        >
          <v-icon left>mdi-cash-check</v-icon>
          Cancelar Deuda
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn dark color="#24232d" @click="show = false">
          <v-icon left>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
      </v-card-actions>
    </v-card>
    <CancelarDeudaCuentaCorriente
      :visible="showCancelarDeuda"
      :idPaciente="idPaciente"
      :saldoDeudor="saldoTotal"
      :jugadorNombre="jugadorNombreCompleto"
      @close="cierraCancelarDeuda"
      @pagado="handlePagado"
    ></CancelarDeudaCuentaCorriente>
  </v-dialog>
</template>

<script>
import axios from "@/axios-auth";
import { showAlert } from "@/utils/toast";
import CancelarDeudaCuentaCorriente from "./CancelarDeudaCuentaCorriente.vue";

export default {
  components: {
    CancelarDeudaCuentaCorriente,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    idPaciente: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      jugador: null,
      movimientos: [],
      saldoTotal: 0,
      showCancelarDeuda: false,
      headers: [
        { text: "Fecha", value: "fechaString" },
        { text: "Tipo", value: "tipo" },
        { text: "Monto", value: "monto" },
        { text: "Observaciones", value: "observaciones" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    jugadorNombreCompleto() {
      if (this.jugador) {
        return `${this.jugador.apellidos}, ${this.jugador.nombres}`;
      }
      return "";
    },
  },
  watch: {
    visible(val) {
      if (val && this.idPaciente) {
        this.cargarDetalle();
      }
    },
  },
  methods: {
    eliminarMovimiento(item) {
      this.$swal({
        title: "Eliminar Movimiento",
        text: "¿Desea eliminar este movimiento de la cuenta corriente?",
        icon: "warning",
        type: "warning",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
        .then((result) => {
          if (result.value) {
            let self = this;
            axios
              .get("/Caja/EliminarMovimientoCuentaCorriente?", {
                params: {
                  idMovimiento: item.idCuentaCorriente,
                },
              })
              .then((response) => {
                self.showAlert({
                  icon: "success",
                  title: "Movimiento eliminado exitosamente.",
                  vm: self,
                  timer: 2000,
                });
                self.cargarDetalle();
              })
              .catch((error) => {
                self.showAlert({
                  icon: "warning",
                  title: "No se pudo eliminar el movimiento.",
                  vm: self,
                  timer: 2000,
                });
              });
          } else if (result.dismiss) {
            // Cancelado - no hacer nada, mantener el modal abierto
            return false;
          }
        })
        .catch(() => {
          // Prevenir que cualquier error cierre el modal
          return false;
        });
    },
    abrirCancelarDeuda() {
      this.showCancelarDeuda = true;
    },
    cierraCancelarDeuda() {
      this.showCancelarDeuda = false;
    },
    handlePagado() {
      this.showCancelarDeuda = false;
      this.cargarDetalle();
    },
    cargarDetalle() {
      this.loading = true;
      const params = {
        idPaciente: this.idPaciente,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };

      let self = this;
      axios
        .get("/Caja/GetDetalleCuentaCorriente", { params })
        .then(function (response) {
          if (response.data) {
            self.jugador = response.data.jugador;
            self.movimientos = response.data.movimientos || [];
            self.saldoTotal = response.data.saldoTotal || 0;
          }
          self.loading = false;
        })
        .catch(function (error) {
          self.loading = false;
          self.showAlert({
            icon: "error",
            title: "Error al cargar el detalle de la cuenta corriente.",
            vm: self,
            timer: 2000,
          });
        });
    },
    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
  },
};
</script>
